import React, { useState, useEffect } from "react";
import ModalComp from "../themes/Model";
import {
  Alert,
  Box,
  Button,
  createTheme,
  Snackbar,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import api from "../axiosConfig";
import { getUser } from "../helpers";
import { useModalContext } from "../ModalContext";
import { LoadingButton } from "@mui/lab";

function MultiplePriceListEdit({
  open,
  handleMultiModelClose,
  filteredRows,
  setMultiEditModel,
  // updateRowData,
  isAccountTab,
  selectedRowData,
  priceListResponse,
}) {
  //data grid
  const [rowData, setRowData] = useState([]);
  //data grid edit cell
  const [cellModesModel, setCellModesModel] = useState({});
  const [editedMRP, setEditedMRP] = useState(null);
  const [IsRetailerEdited, setRetailerEdited] = useState(null);
  const [IsTaxEdited, setTaxEdited] = useState(null);
  const [calculatedPtrValue, setCalculatedPtrValue] = useState(null);
  const [calculatedNetPtrValue, setCalculatedNetPtrValue] = useState(null);
  const [isEditedDate, setEditedDate] = useState(null);
  const [calculatedToDate, setCalculatedToDate] = useState(null);
  //month year controller
  const searchParams = new URLSearchParams();
  const monthYear = dayjs(searchParams.get("monthYear"));
  //apply all
  const [newFromDate, setNewFromDate] = useState(null);
  const [newMRP, setNewMRP] = useState("");
  const [newRetailerMargin, setNewRetailerMargin] = useState("");
  const [newTax, setNewTax] = useState("");
  const [isApplyAll, setApplyAll] = useState(false);
  const [originalRowData, setOriginalRowData] = useState([]);
  //date picker clear, loading row data
  const [cleared, setCleared] = React.useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  //alert message
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  //user
  const user = getUser();
  //context
  const { currency } = useModalContext();

  //[alert handler]
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  //handle clear new values

  const handleClearNewValues = () => {
    setNewFromDate(null);
    setNewMRP("");
    setNewRetailerMargin("");
    setNewTax("");
  };



  useEffect(() => {
    if (open && priceListResponse) {
      setIsLoading(true);
      const processedData = priceListResponse.map((row, index) => {
        // Process and format your row as needed
        return {
          ...row,
          Retailer_Margin: `${(row.Retailer_Margin * 100).toFixed(2)} `,
          Tax: `${row.Tax * 100} `,
          PTR: row.PTR.toFixed(2),
          Net_PTR: row.Net_PTR.toFixed(2),
        };
      });
      setOriginalRowData(processedData);
      setRowData(processedData);
      setIsLoading(false);
      setInitialLoad(false);
    }
  }, [priceListResponse, open]);

  // Add cleanup effect for modal close
  useEffect(() => {
    if (!open) {
      // Reset all relevant states when modal closes
      setRowData([]);
      setOriginalRowData([]);
      setIsLoading(true);
      setInitialLoad(true);
      handleClearNewValues();
    }
  }, [open]);

  //api

  const updateMultiEdit = () => {
    // Filter only the rows where From Date or Retailer Margin has changed
    setIsLoading(true);
    const editedRows = rowData?.filter((row) => {
      const originalRow = originalRowData.find((r) => r.id === row.id);

      return (
        originalRow &&
        (row.From_Date !== originalRow.From_Date ||
          row.Retailer_Margin !== originalRow.Retailer_Margin)
      );
    });

    if (editedRows.length === 0) {
      setSnackbarMessage("No changes detected.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    const apiEndpoint = "api/addpricelstinsertmultiple";

    const payload = {
      data: editedRows,
      page: "pricelist",
      user: user,
      currencyType: currency,
    };

    api
      .post(apiEndpoint, { body: payload })
      .then((response) => {
        console.log("Update Multi Edit Response:", response.data);
        if (response.data?.Status) {
          setSnackbarMessage("Rows updated successfully.");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          setMultiEditModel(false);
          setIsLoading(false);
        } else {
          setSnackbarMessage("Failed to update rows.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
          setIsLoading(false);
          setMultiEditModel(true);
        }
      })
      .catch((error) => {
        console.error("Error updating multi-edit rows:", error);
        setSnackbarMessage("Error updating rows. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setMultiEditModel(true);
        setIsLoading(false);
      });
  };


  //clear date function
  React.useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);

      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [cleared]);

  //handle cell edit start
  const handleCellEditStart = () => {
    // Access the column being edited
    setApplyAll(false);
  };
  //handle cell edit stop
  const handleCellEditStop = () => {
    // Clear the editing column when editing stops
    setApplyAll(false);
  };

  //ADD MORE Editable Field HERE  (function for the DataGrid)
  const isCellEditable = (params) => {
    return [""].includes(params.field);
  };
  //handle cell click
  const handleCellClick = (params, event) => {
    if (!params.isEditable) return;

    // Ignore clicks outside the cell
    if (
      event.target.nodeType === 1 &&
      !event.currentTarget.contains(event.target)
    ) {
      return;
    }

    setCellModesModel((prevModel) => ({
      ...prevModel,
      [params.id]: {
        ...prevModel[params.id],
        [params.field]: { mode: "edit" }, // Enable edit mode for clicked cell
      },
    }));
  };

  //reusable to date calculation
  const addDate = (date) => {
    const fromDateObj = new Date(date);
    return new Date(fromDateObj.setFullYear(fromDateObj.getFullYear() + 15));
  };

  // Columns configuration for the DataGrid
  const columns = [
    {
      field: "id",
      headerName: "id",
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      hideable: true,
    },
    {
      field: "Warehouse",
      headerName: "Warehouse",
      editable: false,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "Product_Name",
      headerName: "Product Name",
      width: 150,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "Category",
      headerName: "Category",
      editable: false,
      disableColumnMenu: true,
      sortable: false,
    },
    ...(isAccountTab
      ? [
          {
            field: "Pricelist",
            headerName: "Pricelist",
            editable: false,
            disableColumnMenu: true,
            sortable: false,
            width: 150,
          },
        ]
      : []),
    {
      field: "MRP",
      headerName: "MRP",
      editable: true,
      type: "number",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        // Safeguard against null or undefined params.row or editedMRP
        if (!params.row) return null;

        const displayValue = editedMRP?.[params.row.id] ?? params.value;

        return (
          <div
            style={{
              fontSize: "12px",
              paddingRight: "0px",
              textAlign: "right",
              width: "100%",
            }}
          >
            {displayValue}
          </div>
        );
      },
    },

    {
      field: "Retailer_Margin",
      headerName: "Retailer Margin %",
      editable: true,
      type: "number",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        // Safeguard against null or undefined params.row or editedRetailerMargin
        if (!params.row) return null;

        const displayValue = IsRetailerEdited?.[params.row.id] ?? params.value;

        return (
          <div
            style={{
              fontSize: "12px",
              paddingRight: "0px",
              textAlign: "right",
              width: "100%",
            }}
          >
            {displayValue}
          </div>
        );
      },
    },
    {
      field: "PTR",
      headerName: "PTR",
      type: "number",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        // Calculate PTR using latest MRP and Retailer Margin
        const MRP = editedMRP?.[params.row.id] ?? params.row.MRP;
        const RetailerMargin =
          IsRetailerEdited?.[params.row.id] ?? params.row.Retailer_Margin;
        const PTR = MRP - MRP * (RetailerMargin / 100);

        return (
          <div
            style={{
              fontSize: "12px",
              paddingRight: "0px",
              textAlign: "right",
              width: "100%",
            }}
          >
            {PTR.toFixed(2)} {/* Display the calculated PTR */}
          </div>
        );
      },
    },

    {
      field: "Tax",
      headerName: "Tax %",
      editable: true,
      type: "number",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        // Safeguard against null or undefined params.row or editedTax
        if (!params.row) return null;

        const displayValue = IsTaxEdited?.[params.row.id] ?? params.value;

        return (
          <div
            style={{
              fontSize: "12px",
              paddingRight: "0px",
              textAlign: "right",
              width: "100%",
            }}
          >
            {displayValue}
          </div>
        );
      },
    },

    {
      field: "Net_PTR",
      headerName: "Net PTR",
      type: "number",
      disableColumnMenu: true,
      sortable: false,
      type: "rightAligned",
      renderCell: (params) => {
        // Get MRP, RetailerMargin, and Tax values
        const MRP = editedMRP?.[params.row.id] ?? params.row.MRP;
        const RetailerMargin =
          IsRetailerEdited?.[params.row.id] ?? params.row.Retailer_Margin;

        // Use IsTaxEdited for Tax value, if it's edited
        const Tax = IsTaxEdited?.[params.row.id] ?? params.row.Tax;

        // Calculate PTR with RetailerMargin as percentage
        const PTR = MRP - MRP * (RetailerMargin / 100);

        // Calculate Net PTR
        const NetPTR = PTR / (1 + Tax / 100);

        // Display the calculated Net PTR value
        return (
          <div
            style={{
              fontSize: "12px",
              paddingRight: "0px",
              textAlign: "right",
              width: "100%",
            }}
          >
            {NetPTR.toFixed(2)} {/* Display Net PTR with two decimal places */}
          </div>
        );
      },
    },

    {
      field: "From_Date",
      headerName: "From Date",
      editable: true,
      disableColumnMenu: true,
      sortable: false,
      type: "date",
      valueFormatter: (params) => {
        // Format the Date object back to a string for display
        if (!params) return ""; // Handle empty values
        return new Date(params).toLocaleDateString("en-US");
      },
      renderEditCell: (params) => {
        // Convert the current value to a `dayjs` object for the DatePicker
        const currentValue = params.value ? dayjs(params.value) : null;

        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box className="multiedit-date-picker">
              <DatePicker
                value={currentValue} // Pass the `dayjs` object
                onChange={(newValue) => {
                  // Convert the `dayjs` object to a JavaScript Date object
                  const dateValue = newValue ? newValue.toDate() : null;

                  // Update the cell value in the grid
                  params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: dateValue,
                  });
                }}
                disablePast={true}
                shouldDisableDate={(date) => {
                  const dayjsDate = dayjs(date); // Convert to Day.js instance
                  const today = dayjs().startOf("day");
                  const tomorrow = today.add(1, "day");

                  return (
                    dayjsDate.isBefore(monthYear.startOf("month"), "day") ||
                    dayjsDate.isAfter(monthYear.endOf("month"), "day") ||
                    dayjsDate.isSame(today, "day") ||
                    dayjsDate.isSame(tomorrow, "day")
                  );
                }}
              />
            </Box>
          </LocalizationProvider>
        );
      },
    },
    {
      field: "To_Date",
      headerName: "To Date",
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      type: "date",
      valueFormatter: (params) => {
        // Format the Date object back to a string for display
        if (!params) return ""; // Handle empty values
        return new Date(params).toLocaleDateString("en-US");
      },
      // renderEditCell: (params) => {
      //   // Convert the current value to a `dayjs` object for the DatePicker
      //   const currentValue = params.value ? dayjs(params.value) : null;

      //   return (
      //     <LocalizationProvider dateAdapter={AdapterDayjs}>
      //       <Box className="multiedit-date-picker">
      //         <DatePicker
      //           value={currentValue} // Pass the `dayjs` object
      //           onChange={(newValue) => {
      //             // Convert the `dayjs` object to a JavaScript Date object
      //             const dateValue = newValue ? newValue.toDate() : null;

      //             // Update the cell value in the grid
      //             params.api.setEditCellValue({
      //               id: params.id,
      //               field: params.field,
      //               value: dateValue,
      //             });
      //           }}
      //           disablePast={true}
      //         />
      //       </Box>
      //     </LocalizationProvider>
      //   );
      // },
    },
  ];
  // Calculate the To Date based on the From Date
  const calculateToDate = (fromDate) => {
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(
      fromDateObj.setFullYear(fromDateObj.getFullYear() + 15)
    );
    setCalculatedToDate(toDateObj);
    return toDateObj.toLocaleDateString("en-US");
  };

  // Process row update data grid calculation
  const processRowUpdate = (newRow, oldRow, params) => {
    if (isApplyAll) {
      return false;
    }
    // Check if MRP or Retailer Margin has changed
    if (
      newRow.MRP !== oldRow.MRP ||
      newRow.Retailer_Margin !== oldRow.Retailer_Margin
    ) {
      // Calculate PTR based on updated MRP and Retailer Margin
      const newPTR = newRow.MRP - newRow.MRP * (newRow.Retailer_Margin / 100);
      newRow.PTR = newPTR.toFixed(2); // Set PTR value with two decimal places

      // Calculate Net PTR based on the formula
      const newNetPTR = newPTR / (1 + newRow.Tax / 100);
      newRow.Net_PTR = newNetPTR.toFixed(2);
    }

    if (newRow.From_Date !== oldRow.From_Date) {
      const toDateObj = calculateToDate(newRow.From_Date);
      // newRow.To_Date = toDateObj.toLocaleDateString("en-US"); // Format for display
      setCalculatedToDate(toDateObj); // Update state with the Date object
    }

    let updatedToDate = oldRow.To_Date;
    if (newRow.From_Date !== oldRow.From_Date) {
      const toDateObj = addDate(newRow.From_Date);
      updatedToDate = toDateObj.toLocaleDateString("en-US");
    }

    // Update row data with new MRP, Retailer Margin, and calculated PTR
    setRowData((prevRows) =>
      prevRows?.map((row) =>
        row.id === newRow.id
          ? {
              ...row,
              MRP: newRow.MRP, // Updated MRP
              Retailer_Margin: newRow.Retailer_Margin, // Updated Retailer Margin
              PTR: newRow.PTR, // Updated PTR value
              Tax: newRow.Tax, // Updated Tax value
              Net_PTR: newRow.Net_PTR,
              From_Date: newRow.From_Date,
              To_Date: updatedToDate,
            }
          : row
      )
    );

    if (newRow.From_Date !== oldRow.From_Date) {
      setEditedDate((prev) => ({
        ...prev,
        [newRow.id]: newRow.From_Date,
      }));
    }

    // Update state for edited MRP
    if (newRow.MRP !== oldRow.MRP) {
      setEditedMRP((prev) => ({
        ...prev,
        [newRow.id]: newRow.MRP,
      }));
    }

    // Update state for edited Retailer Margin
    if (newRow.Retailer_Margin !== oldRow.Retailer_Margin) {
      setRetailerEdited((prev) => ({
        ...prev,
        [newRow.id]: newRow.Retailer_Margin,
      }));
    }

    // Update state for edited Tax
    if (newRow.Tax !== oldRow.Tax) {
      setTaxEdited((prev) => ({
        ...prev,
        [newRow.id]: newRow.Tax,
      }));
    }

    // Update state for calculated PTR
    if (newRow.PTR !== oldRow.PTR) {
      setCalculatedPtrValue((prev) => ({
        ...prev,
        [newRow.id]: newRow.PTR,
      }));
    }

    if (newRow.Net_PTR !== oldRow.Net_PTR) {
      setCalculatedNetPtrValue((prev) => ({
        ...prev,
        [newRow.id]: newRow.Net_PTR,
      }));
    }

    return {
      ...newRow,
      To_Date: updatedToDate,
    };
  };

  // Row update error handler
  const handleRowUpdateError = (error) => {
    console.error("Row update error:", error);
  };

  // Update row data  retailer, mrp, tax, from-date whenever inputs change
  useEffect(() => {
    setRowData((prevRows) =>
      prevRows?.map((row) => {
        const updatedRow = { ...row };

        if (newFromDate) {
          const formattedDate = dayjs(newFromDate).format("YYYY-MM-DD");
          updatedRow.From_Date = formattedDate;
          setEditedDate("");

          const toDateObj = addDate(newFromDate);
          updatedRow.To_Date = dayjs(toDateObj).format("YYYY-MM-DD");
        } else {
          // Revert to original dates if no new date is provided
          const originalRow = originalRowData.find((r) => r.id === row.id);
          if (originalRow) {
            updatedRow.From_Date = originalRow.From_Date;
            updatedRow.To_Date = originalRow.To_Date;
          }
          setEditedDate("");
        }

        // Update MRP
        if (newMRP !== "") {
          updatedRow.MRP = newMRP;
          setEditedMRP("");
        }

        // Update Retailer Margin
        if (newRetailerMargin !== "") {
          updatedRow.Retailer_Margin = newRetailerMargin;
          setRetailerEdited("");
        } else {
          // revert the original margin value if no new date is provided
          const originalRow = originalRowData.find((r) => r.id === row.id);
          if (originalRow) {
            updatedRow.Retailer_Margin = originalRow.Retailer_Margin;
          }
        }

        // Update Tax
        if (newTax !== "") {
          updatedRow.Tax = newTax;
          setTaxEdited("");
        }

        // Calculate PTR
        updatedRow.PTR = (
          updatedRow.MRP -
          updatedRow.MRP * (updatedRow.Retailer_Margin / 100)
        )?.toFixed(2);

        // Calculate Net PTR
        updatedRow.Net_PTR = (
          updatedRow.PTR /
          (1 + updatedRow.Tax / 100)
        )?.toFixed(2);

        return updatedRow;
      })
    );
  }, [newFromDate, newMRP, newRetailerMargin, newTax]); // Runs when any of these values change

  // Theme for the DataGrid
  const theme = createTheme({
    components: {
      MuiDataGrid: {
        styleOverrides: {
          root: {
            fontSize: "14px", // Change this to your desired font size
          },
          columnHeaders: {
            fontSize: "14px", // Font size for column headers
          },
          row: {
            fontSize: "12px", // Font size for rows
          },
        },
      },
    },
  });

  // Modal content with DataGrid
  const modalContent = (
    <>
      <Box
        sx={{
          display: "flex",
          gap: "8px",
          flexDirection: "row",
          justifyContent: "end",
          alignItems: "end",
          width: "100%",
          marginBottom: "12px",
        }}
        className="scheme-date-picker pricelist-date-picker"
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="From Date"
            value={newFromDate}
            onChange={(date) => setNewFromDate(date)}
            renderInput={(params) => <TextField {...params} size="small" />}
            disablePast={true}
            shouldDisableDate={(date) => {
              const dayjsDate = dayjs(date); // Convert to Day.js instance
              const today = dayjs().startOf("day");
              const tomorrow = today.add(1, "day");

              return (
                dayjsDate.isBefore(monthYear.startOf("month"), "day") ||
                dayjsDate.isAfter(monthYear.endOf("month"), "day") ||
                dayjsDate.isSame(today, "day") ||
                dayjsDate.isSame(tomorrow, "day")
              );
            }}
            slotProps={{
              field: { clearable: true, onClear: () => setCleared(true) },
            }}
            sx={{
              "& .MuiInputBase-root": {
                maxWidth: "200px !important",
              },
            }}
          />
        </LocalizationProvider>

        {!isAccountTab && (
          <TextField
            label={"MRP"}
            id="MRP"
            value={newMRP}
            onChange={(e) => setNewMRP(e.target.value)}
            size="small"
          />
        )}

        <TextField
          label={"Retailer Margin %"}
          id="Retailer Margin %"
          value={newRetailerMargin}
          onChange={(e) => setNewRetailerMargin(e.target.value)}
          size="small"
        />
        {!isAccountTab && (
          <TextField
            label={"Tax %"}
            id="Tax %"
            value={newTax}
            onChange={(e) => setNewTax(e.target.value)}
            size="small"
          />
        )}
      </Box>
      <div style={{ height: 6 * 35 + 56 + "px", width: "100%" }}>
        <ThemeProvider theme={theme}>
          <DataGrid
            rows={rowData?.map((row) => ({
              ...row,
            }))}
            columns={columns}
            isCellEditable={isCellEditable}
            onCellClick={handleCellClick}
            disableSelectionOnClick
            processRowUpdate={processRowUpdate}
            onProcessRowUpdateError={handleRowUpdateError}
            experimentalFeatures={{ newEditingApi: true }}
            editMode="cell" // Enable cell-level editing
            onCellEditStart={handleCellEditStart}
            onCellEditStop={handleCellEditStop}
            cellModesModel={cellModesModel}
            onCellModesModelChange={(newModel) => setCellModesModel(newModel)}
            loading={isLoading || initialLoad}
            rowHeight={40}
            headerHeight={56}
            autoHeight={false}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                position: "sticky",
                top: 0,
                zIndex: 1000,
              },
              "& .MuiDataGrid-cell.MuiDataGrid-cell--editable": {
                backgroundColor: "#AEF4EC", // Highlight editable fields
                color: "#000",
              },
              "& .MuiDataGrid-cell.MuiDataGrid-cell--editable:focus-within": {
                outline: "none",
                backgroundColor: "#D8F7F1",
              },
              "& .MuiDataGrid-cell.MuiDataGrid-cell--editable input": {
                fontSize: "12px",
                color: "#000",
                textAlign: "right",
              },
              "& .MuiCircularProgress-root": {
                color: "#17A591",
                width: "35px",
                height: "35px",
              },
            }}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  id: false,
                },
              },
            }}
          />
        </ThemeProvider>
      </div>
    </>
  );

  // Modal action buttons
  const actionButtons = (
    <>
      <LoadingButton
        variant="contained"
        color="primary"
        disabled={!newFromDate || !newRetailerMargin}
        loading={isLoading}
        loadingPosition="end"
        onClick={() => {
          handleMultiModelClose();
          // updateRowData(rowData);
          updateMultiEdit();
        }}
        style={{
          opacity: !newFromDate || !newRetailerMargin ? 0.5 : 1,
          pointerEvents: !newFromDate || !newRetailerMargin ? "none" : "auto",
          fontSize: "12px",
          backgroundColor: "#16a695",
          color: "white",
          backgroundColor: isLoading ? "#16a69590" : "#16a695",
          paddingRight: isLoading ? "35px" : "",
          marginRight: "8px",
        }}
        size="small"
      >
        {isLoading ? "Updating..." : "Update"}
      </LoadingButton>

      <Button
        variant="outlined"
        onClick={() => {
          handleMultiModelClose();
          handleClearNewValues();
        }}
        style={{ fontSize: "12px", color: "#000", borderColor: "#707070" }}
        size="small"
      >
        Cancel
      </Button>
    </>
  );

  return (
    <>
      <ModalComp
        open={open}
        setMultiEditModel={setMultiEditModel}
        handleMultiModelClose={handleMultiModelClose}
        title={
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: 600,
                  margin: "0",
                }}
              >
                {"Account Price"}
              </p>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                }}
              >
                {isLoading || initialLoad ? (
                  <p
                    style={{
                      fontSize: "12px",
                      color: "rgba(0, 0, 0, 0.6)",
                      margin: "0",
                    }}
                  >
                    Loading data...
                  </p>
                ) : (
                  <>
                    {priceListResponse?.[0].Pricelist},{" "}
                    {priceListResponse?.[0].Product_Name}
                  </>
                )}
              </span>
            </div>
          </>
        }
        modalContent={modalContent}
        modelButtons={actionButtons}
        themeStyles={{
          boxStyle: {
            width: "fit-content",
            height: "fit-content",
            margin: "auto",
            marginTop: "40px",
          },
          titleStyle: {
            fontSize: "18px",
            fontWeight: 600,
            color: "#000",
            backgroundColor: "#F4F4F4",
            padding: "24px",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          fieldStyle: { width: "100%", marginTop: "20px" },
        }}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default MultiplePriceListEdit;
